"use client";

import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { Check, ChevronDown } from "lucide-react";
import { usePathname } from "next/navigation";
import { BCP47LangCode } from "@/core/i18n/i18n.types";
import { persistLanguagePreferenceCookie, readCurrentSearchParams, replacePathLocale } from "@/core/i18n/languageSwitch/languageSwitch.utils";
import { useI18n } from "@/core/i18n/useI18n/useI18n";
import { useTranslation } from "@/core/i18n/useTranslation.client";
import { appendTrackingSearch } from "@/core/tracking";
const LANGUAGE_DISPLAY: Record<BCP47LangCode, string> = {
  "en-US": "United States · English",
  "en-CA": "Canada · English",
  "es-MX": "México · Español",
  "fr-CA": "Canada · Français",
  "en-BR": "Brasil · English",
  "pt-BR": "Brasil · Português"
};
const FooterLanguageSwitcher = () => {
  const {
    currentLang,
    languages
  } = useI18n();
  const {
    t
  } = useTranslation();
  const pathname = usePathname();
  const handleSelect = (newLang: BCP47LangCode) => {
    if (newLang === currentLang) return;
    persistLanguagePreferenceCookie(newLang);
    const newPath = replacePathLocale(pathname, currentLang, newLang);
    window.location.href = appendTrackingSearch(newPath, readCurrentSearchParams());
  };
  return <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button aria-label={t("footer.changeLanguage")} className="type-caption hover:text-champagne-white inline-flex cursor-pointer items-center gap-2 rounded-[1px] border border-white/15 px-3 py-1.5 transition-colors focus:outline-none focus-visible:ring-1 focus-visible:ring-white/30" style={{
        color: "var(--on-dark-muted)"
      }} type="button">
          <span>{LANGUAGE_DISPLAY[currentLang]}</span>
          <ChevronDown aria-hidden="true" className="h-3.5 w-3.5" />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content align="start" className="z-50 min-w-[var(--radix-dropdown-menu-trigger-width)] overflow-hidden rounded-[2px] border border-white/10 bg-[#281D1A] p-1 shadow-lg" sideOffset={6}>
          {languages.map(lang => {
          const isActive = lang === currentLang;
          return <DropdownMenu.Item key={lang} className={`type-caption text-champagne-white data-[highlighted]:text-amber flex cursor-pointer items-center justify-between gap-3 rounded-[1px] px-3 py-2 transition-colors outline-none data-[highlighted]:bg-white/5 ${isActive ? "text-amber" : ""}`} onSelect={() => handleSelect(lang)}>
                <span>{LANGUAGE_DISPLAY[lang]}</span>
                {isActive ? <Check aria-hidden="true" className="h-3.5 w-3.5" /> : null}
              </DropdownMenu.Item>;
        })}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>;
};
export default FooterLanguageSwitcher;